import { FC } from 'react';
import { Button, ButtonGroup, Dropdown, Spinner } from "react-bootstrap";
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faFileCsv, faFileExport } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  onClick: (type: string) => void;
  isLoading?: boolean;
  hideExcel?: boolean; // padrão false
  hideCsv?: boolean;   // padrão false
}

const DropdownButtonExport: FC<IProps> = ({
  onClick,
  isLoading,
  hideExcel = false,
  hideCsv = false
}) => {
  return (
    <Dropdown as={ButtonGroup}>
      <Button variant="primary">
      {isLoading &&
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      }
        <FontAwesomeIcon icon={faFileExport} className='me-2' />
        <span>{t("EXPORT")}</span>
      </Button>

      <Dropdown.Toggle split variant="primary" id="dropdown-split-basic" />

      <Dropdown.Menu>
        {!hideExcel && (
          <Dropdown.Item className='fw-bold' onClick={() => onClick("Excel")}>
            <FontAwesomeIcon icon={faFileExcel} className='me-2' /> Excel
          </Dropdown.Item>
        )}
        {!hideCsv && (
          <Dropdown.Item className='fw-bold' onClick={() => onClick("Csv")}>
            <FontAwesomeIcon icon={faFileCsv} className='me-2' /> CSV
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default DropdownButtonExport;